import React, { useState, useEffect, createContext, useContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import axios from "axios";
import { API } from "../../../services/api";
import { UserContext } from "../../../App";
import PurchaseOrderDetail from "./update/PurchaseOrderDetail";
import CreateReceiveProduct from "./create/createReceiveProduct";
import { format } from "date-fns";

axios.defaults.baseURL = API;

const PendingBillContent = createContext();

function OrderBill() {

  function getDate(gdate) {
    var date = new Date(gdate);
    return format(date, "dd-MM-yyyy HH:mm");
  }
  const {LocationID, userID, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);
  const [dataList, setDataList] = useState([]);
  const [PurchaseOrderDetails, setPurchaseOrderDetail] = useState([]);
  const [PurchaseOrderID, setPurchaseOrderID] = useState();
  const [EmployeeList, setEmployeeList] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showReceive, setShowReceive] = useState(false);
  const handleCloseReceive = () => setShowReceive(false);
  const handleShowReceive = () => setShowReceive(true);

  async function getPendingBill() {
    var StatusID = 5;
    await axios.get(`/getPurchaseOrderBill/${LocationID}/${StatusID}`).then((response) => {
        let Data = response?.data;
        setDataList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function openProductDetail(PurchaseOrderID) {
    axios
      .get(`/getPurchaseOrderProduct/${PurchaseOrderID}`)
      .then((response) => {
        let Data = response?.data;
        setPurchaseOrderDetail(Data);
        handleShow();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function createReceiveProduct(PurchaseOrderID) {
    axios
      .get(`/getPurchaseOrderProduct/${PurchaseOrderID}`)
      .then((response) => {
        let Data = response?.data;
        setPurchaseOrderDetail(Data);
        setPurchaseOrderID(PurchaseOrderID)
        handleShowReceive();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getUserByLocationID() {
      let token = localStorage.getItem("token");
      await axios.get(`/getUserByLocationID/${LocationID}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        let temOrder = response?.data;
        console.log(temOrder)
        if(temOrder.length > 0){
          setEmployeeList(temOrder);
        } else {
          setEmployeeList([]);
        }
      }).catch((err) => {
          console.log(err);
      });
  }

  const handleclickBack = () => {
      setShowForm(false);
      setshowSubmenu(true);
  };

  useEffect(() => {
    getUserByLocationID();
    getPendingBill();
  }, []);

  return (
    <PendingBillContent.Provider value={{ setDataList, PurchaseOrderDetails, EmployeeList, PurchaseOrderID}}>
      <div className="formContent">
        <PurchaseOrderDetail show={show} onClick={handleClose}/>
        <CreateReceiveProduct show={showReceive} onClick={handleCloseReceive}/>
        <div className="formCard">
        <div className="Header">
          <div className="title">
              <span>ບິນລໍຖ້າຮັບເຄື່ອງເຂົ້າສາງ</span>
          </div>
          <div className="buttonContent">
              <button className="btn btn-danger" onClick={() => handleclickBack()} >Back</button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th className="NO">ລ/ດ</th>
                <th className="PurchaseOrderID">ເລກບິນ</th>
                <th className="SupplierName">ຜູ້ສະໜອງ</th>
                <th className="PaymentType">ປະເພດຈ່າຍ</th>
                <th className="CreatedDate">ມື້ສ້າງ</th>
                <th className="buttonContent">Action</th>
              </tr>
            </thead>
            <tbody>
              {
                dataList && dataList.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td className="NO">{y + 1}</td>
                        <td className="PurchaseOrderID">{x.PurchaseOrderID}</td>
                        <td className="SupplierName">{x.SupplierName}</td>
                        <td className="PaymentType">{x.PaymentType}</td>
                        <td className="CreatedDate">{getDate(x.CreatedDate)}</td>
                        <td className="buttonContent">
                          <button className="btn btn-warning" type="button" onClick={() => openProductDetail(x.PurchaseOrderID)}>ລາຍລະອຽດ</button>
                          &nbsp;&nbsp;&nbsp;
                          <button className="btn btn-primary" type="button" onClick={() => createReceiveProduct(x.PurchaseOrderID)}>ຮັບເຄື່ອງເຂົ້າສາງ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
        </div>
      </div>
    </PendingBillContent.Provider>
  );
};

export {PendingBillContent};
export default OrderBill;
